
import type { DayOfWeek } from '../types';

export const getWeekStartDate = (date: Date, startDayIndex: number = 1): Date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    const diff = d.getDate() - ((day - startDayIndex + 7) % 7);
    return new Date(d.setDate(diff));
};

export const getWeekDates = (startDate: Date): Date[] => {
    const dates: Date[] = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(startDate);
        d.setDate(d.getDate() + i);
        dates.push(d);
    }
    return dates;
};

export const formatDateYYYYMMDD = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatDayAndDate = (date: Date): { day: string, date: string } => {
    const day = date.toLocaleDateString('en-US', { weekday: 'short' });
    const dateNum = date.getDate().toString();
    return { day, date: dateNum };
};

export const formatDateRange = (startDate: Date): string => {
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    const startMonth = startDate.toLocaleDateString('en-US', { month: 'short' });
    const endMonth = endDate.toLocaleDateString('en-US', { month: 'short' });

    if (startMonth === endMonth) {
        return `${startMonth} ${startDate.getDate()} - ${endDate.getDate()}, ${startDate.getFullYear()}`;
    } else {
        return `${startMonth} ${startDate.getDate()} - ${endMonth} ${endDate.getDate()}, ${startDate.getFullYear()}`;
    }
};

export const getDayOfWeekFromDate = (date: Date): DayOfWeek => {
    return date.toLocaleDateString('en-US', { weekday: 'long' }) as DayOfWeek;
}